import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './router.tsx';
import { TimerProvider } from './contextes/TimerProvider.tsx';
import { SoundProvider } from './contextes/SoundContext.tsx';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <TimerProvider>
            <SoundProvider>
                <App />
            </SoundProvider>
        </TimerProvider>
    </StrictMode>
);
